const ModuleList = [
    {
      icon: 'redeem',
      link: '/club-actions',
      name: 'Sale',
      translatedName: 'Clubacties',
    },
    {
      icon: 'shield',
      link: '/club',
      name: 'ClubPage',
      translatedName: 'Clubs'
    },
    {
      icon: 'event',
      link: '/events',
      name: 'Events',
      translatedName: 'Evenementen',
    },
    {
      icon: 'newspaper',
      link: '/news',
      name: 'News',
      translatedName: 'Nieuws',
    },
    {
      icon: 'hive',
      link: '/groups',
      name: 'Groups',
      translatedName: 'Groepen',
    },
    {
      icon: 'apartment',
      link: '/company',
      name: 'CompanyPage',
      translatedName: 'Bedrijven'
    },
    {
      icon: 'groups',
      link: '/admins',
      name: 'Admins',
      translatedName: 'Admins',
    },
    {
      icon: 'lock_person',
      link: '/roles',
      name: 'roles',
      translatedName: 'Rollen & Rechten',
    },
    {
      icon: 'help',
      link: '/faq',
      name: 'Question',
      translatedName: 'Veelgestelde vragen'
    },
    {
      icon: 'folder',
      link: '/file-browser',
      name: 'Documents',
      translatedName: 'Documentbeheer'
    },
    {
      icon: 'poll',
      link: '/polls/',
      name: 'Poll',
      translatedName: 'Peilingen'
    },
    {
      icon: 'feedback',
      link: '/reports',
      name: 'Reports',
      translatedName: 'Meldingen'
    }
];

export default ModuleList;